"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentToString = void 0;
exports.alphaNumericSort = alphaNumericSort;
exports.shuffle = shuffle;

var ContentToString = function ContentToString(content) {
  if (typeof content === "string") {
    return content;
  } else if (Array.isArray(content)) {
    return content.map(function (v) {
      return ContentToString(v);
    }).join('');
  } else if (typeof content === "object" && content.props.children !== undefined) {
    return ContentToString(content.props.children);
  }

  return content;
};

exports.ContentToString = ContentToString;

function alphaNumericSort(a, b) {
  var anumi = -1;
  var bnumi = -1;
  var anum;
  var bnum;

  for (var i = 0; i < Math.min(a.length, b.length); ++i) {
    if (!isNaN(Number(a[i]))) {
      if (anumi === -1) {
        anumi = i;
        anum = undefined;
      }
    } else {
      if (anumi !== -1) {
        anum = Number(a.substring(anumi, i));
        anumi = -1;
      }
    }

    if (!isNaN(Number(b[i]))) {
      if (bnumi === -1) {
        bnumi = i;
        bnum = undefined;
      }
    } else {
      if (bnumi !== -1) {
        bnum = Number(b.substring(bnumi, i));
        bnumi = -1;
      }
    }

    if (anum !== undefined && bnum !== undefined) {
      if (anum < bnum) {
        return -1;
      } else if (bnum < anum) {
        return 1;
      }
    } else if (anum !== undefined) {
      return -1;
    } else if (bnum !== undefined) {
      return 1;
    } else if (anumi === -1 && bnumi === -1) {
      if (a[i] < b[i]) {
        return -1;
      } else if (b[i] < a[i]) {
        return 1;
      }
    }
  }

  if (a.length < b.length) {
    return -1;
  }

  if (b.length < a.length) {
    return 1;
  }

  return 0;
}

function shuffle(a) {
  for (var i = a.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref = [a[j], a[i]];
    a[i] = _ref[0];
    a[j] = _ref[1];
  }

  return a;
}